var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 100,
    viewBox: "0 0 136 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.924 84.6494C135.924 78.2435 130.634 73.0316 124.13 73.0316C122.672 73.0316 121.23 73.3019 119.847 73.8343L119.507 73.9647L119.312 73.6604C116.015 68.4778 110.347 65.3848 104.153 65.3848C97.5659 65.3848 91.5276 68.9373 88.4005 74.6581L88.2455 74.9425L87.9246 74.8767C87.2281 74.7333 86.5221 74.6604 85.828 74.6604C80.2381 74.6604 75.6895 79.1414 75.6895 84.6494C75.6895 85.2441 75.7527 87.8953 75.854 88.4617H135.777C135.864 87.8917 135.924 85.2429 135.924 84.6494Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.012 47.4359C109.012 73.6342 87.4953 94.8718 60.9524 94.8718C34.4098 94.8718 12.8926 73.6342 12.8926 47.4359C12.8926 21.2379 34.4098 0 60.9524 0C87.4953 0 109.012 21.2379 109.012 47.4359Z",
    fill: "#25448C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.604 47.4358C102.604 70.0936 83.9562 88.4614 60.9526 88.4614C37.949 88.4614 19.3008 70.0936 19.3008 47.4358C19.3008 24.778 37.949 6.41016 60.9526 6.41016C83.9562 6.41016 102.604 24.778 102.604 47.4358Z",
    fill: "#F5F7FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9513 20.5131C60.5973 20.5131 60.3105 20.102 60.3105 19.5952V9.8928C60.3105 9.38572 60.5973 8.97461 60.9513 8.97461C61.3054 8.97461 61.5921 9.38572 61.5921 9.8928V19.5952C61.5921 20.102 61.3054 20.5131 60.9513 20.5131Z",
    fill: "#3D64A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.482 29.4871C80.2399 29.4871 79.9971 29.3946 79.8123 29.2098C79.4428 28.8398 79.4428 28.24 79.8123 27.87L86.8899 20.79C87.2598 20.4203 87.8592 20.4203 88.2292 20.79C88.5987 21.16 88.5987 21.7597 88.2292 22.1297L81.1516 29.2098C80.9668 29.3946 80.7241 29.4871 80.482 29.4871Z",
    fill: "#3D64A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.1227 48.7176H89.4234C88.9165 48.7176 88.5059 48.4307 88.5059 48.0766C88.5059 47.7227 88.9165 47.4355 89.4234 47.4355H99.1227C99.6296 47.4355 100.04 47.7227 100.04 48.0766C100.04 48.4307 99.6296 48.7176 99.1227 48.7176Z",
    fill: "#3D64A1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5595 75.6414C87.3174 75.6414 87.0746 75.5489 86.8898 75.3641L79.8123 68.284C79.4428 67.9143 79.4428 67.3142 79.8123 66.9445C80.1823 66.5745 80.7818 66.5745 81.1517 66.9445L88.2291 74.0246C88.5987 74.3943 88.5987 74.9944 88.2291 75.3641C88.0444 75.5489 87.8016 75.6414 87.5595 75.6414Z",
    fill: "#3D64A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.6701 87.1791C59.3161 87.1791 59.0293 86.7683 59.0293 86.2612V76.5585C59.0293 76.0514 59.3161 75.6406 59.6701 75.6406C60.0241 75.6406 60.3109 76.0514 60.3109 76.5585V86.2612C60.3109 86.7683 60.0241 87.1791 59.6701 87.1791Z",
    fill: "#3D64A1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0621 75.6414C32.8196 75.6414 32.5775 75.5489 32.3927 75.3641C32.0228 74.9944 32.0228 74.3943 32.3924 74.0246L39.4699 66.9445C39.8398 66.5745 40.4393 66.5745 40.8089 66.9445C41.1788 67.3142 41.1788 67.9143 40.8093 68.284L33.7317 75.3641C33.547 75.5489 33.3045 75.6414 33.0621 75.6414Z",
    fill: "#3D64A1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1989 48.7176H21.4996C20.993 48.7176 20.582 48.4305 20.582 48.0766C20.582 47.7227 20.993 47.4355 21.4996 47.4355H31.1989C31.7054 47.4355 32.1164 47.7227 32.1164 48.0766C32.1164 48.4305 31.7054 48.7176 31.1989 48.7176Z",
    fill: "#3D64A1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1396 28.2048C39.8971 28.2048 39.655 28.1124 39.4699 27.9276L32.3927 20.8474C32.0228 20.4774 32.0228 19.878 32.3927 19.508C32.7626 19.138 33.3617 19.138 33.7316 19.508L40.8092 26.5878C41.1788 26.9578 41.1788 27.5575 40.8092 27.9276C40.6241 28.1124 40.382 28.2048 40.1396 28.2048Z",
    fill: "#3D64A1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.3109 51.2818C59.603 51.2818 59.0293 50.6773 59.0293 49.9313V28.2737C59.0293 27.5277 59.603 26.9229 60.3109 26.9229C61.0188 26.9229 61.5925 27.5277 61.5925 28.2737V49.9313C61.5925 50.6773 61.0188 51.2818 60.3109 51.2818Z",
    fill: "#2E4477"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.3108 51.2819H61.6603C60.9146 51.2819 60.3105 50.708 60.3105 49.9998C60.3105 49.292 60.9146 48.7178 61.6603 48.7178H83.3108C84.0565 48.7178 84.6608 49.292 84.6608 49.9998C84.6608 50.708 84.0565 51.2819 83.3108 51.2819Z",
    fill: "#2E4477"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6316 33.333C102.546 74.9231 67.4285 87.5096 65.4375 88.4612C85.6502 86.0464 101.322 68.8262 101.322 47.9379C101.322 42.7911 100.368 37.8682 98.6316 33.333Z",
    fill: "#CFE6FD"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.282 95.9196C67.7119 96.0745 66.12 96.1538 64.5096 96.1538C50.0954 96.1538 37.1502 89.8017 28.2695 79.7183C30.5364 78.7444 33.0322 78.2051 35.6552 78.2051C41.9361 78.2051 47.4816 81.3032 50.9115 86.0475C52.669 85.1039 54.6752 84.5639 56.8082 84.5639C63.3133 84.5639 68.6608 89.545 69.282 95.9196Z",
    fill: "#CFE6FD",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.0436 100C65.2917 99.0236 65.4375 98.0059 65.4375 96.9518C65.4375 90.071 59.8359 84.4932 52.9258 84.4932C50.7965 84.4932 48.7939 85.0271 47.0395 85.9602C43.6157 81.2688 38.08 78.2051 31.8102 78.2051C24.4802 78.2051 18.1445 82.385 15.0347 88.4727C13.5545 87.5966 11.8331 87.0851 9.98493 87.0851C4.51342 87.0851 0.0761719 91.5018 0.0761719 96.9518C0.0761719 98.0162 0.251441 99.0392 0.565536 100H65.0436Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.f49ded584907854f727a92b31e77d11d.svg";
export { ForwardRef as ReactComponent };